import type { AppDataTableColumn } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AppMemberDisplay } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { formatDate } from '@/lib/format-utils'
import type { InquiryActionLog } from '../hooks/useInquiryActionLogs'

export function createLogColumns(): AppDataTableColumn<InquiryActionLog>[] {
  return [
    {
      key: 'id',
      label: '管理ID',
      accessor: (row) => row.id,
      render: (row) => <span className='font-mono text-sm'>{row.id}</span>,
    },
    {
      key: 'created_at',
      label: '操作日時',
      accessor: (row) => row.created_at,
      sortable: false,
      render: (row) => (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className='cursor-help'>{formatDate(row.created_at, 'relative')}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{formatDate(row.created_at, 'datetime')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ),
    },
    {
      key: 'member_name',
      label: '実行者名',
      accessor: (row) => row.member_name,
      sortable: false,
      render: (row) => (
        <AppMemberDisplay employeeNumber={row.employee_number} name={row.member_name} emptyDisplay='dash' />
      ),
    },
    {
      key: 'action_type_name',
      label: '操作区分',
      accessor: (row) => row.action_type_name,
      sortable: false,
      render: (row) => <span>{row.action_type_name || '-'}</span>,
    },
    {
      key: 'action_category_name',
      label: '操作対象',
      accessor: (row) => row.action_category_name,
      sortable: false,
      render: (row) => <span>{row.action_category_name || '-'}</span>,
    },
  ]
}
